module.exports = __webpack_public_path__ + "img/car1.414dafb7.png";